export default "__VITE_ASSET__9Q1RPUiF__"